import { all, call, takeEvery, put } from 'redux-saga/effects';
import {
  GET_CURRENT_USER,
  GET_CURRENT_USER_FAIL,
  GET_CURRENT_USER_SUCCESS,
  GET_ACTIVE_LISTINGS,
  SET_SEARCH_PENDING,
  GET_NEED_TO_CONFIRM_ORDERS,
  GET_NEED_TO_SHIP_ORDERS,
  GET_OPEN_ORDERS,
  GET_SHIPPED_ORDERS,
  GET_DELIVERED_ORDERS,
  GET_RETURNED_ORDERS,
  GET_CANCELED_ORDERS,
  GET_COMPLETED_ORDERS,
} from 'store/constants/action-types';
import { fetchUser } from 'services/api/user-api';

export function* getCurrentUser() {
  try {
    const response = yield call(fetchUser);
    yield put({ type: GET_CURRENT_USER_SUCCESS, payload: response });
    yield put({ type: SET_SEARCH_PENDING, payload: true });
    yield put({ type: GET_ACTIVE_LISTINGS });
    yield put({ type: GET_OPEN_ORDERS });
    yield put({ type: GET_NEED_TO_CONFIRM_ORDERS });
    yield put({ type: GET_NEED_TO_SHIP_ORDERS });
    yield put({ type: GET_SHIPPED_ORDERS });
    yield put({ type: GET_COMPLETED_ORDERS });
    yield put({ type: GET_DELIVERED_ORDERS });
    yield put({ type: GET_RETURNED_ORDERS });
    yield put({ type: GET_CANCELED_ORDERS });
  } catch (error) {
    yield put({ type: GET_CURRENT_USER_FAIL });
    console.log(error);
  }
}

export function* watchGetUser() {
  yield takeEvery(GET_CURRENT_USER, getCurrentUser);
}

export default function* userSagas() {
  yield all([watchGetUser()]);
}
